import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'
import L1SearchScreen from './L1SearchScreen'

import ViewTechnology from '../specialist-technology/ViewTechnology'
import PreviewTechnology from '../specialist-technology/PreviewTechnology'
import PreviewAlternative from '../specialist-alternative/PreviewAlternative'
import ViewAlternative from '../specialist-alternative/ViewAlternative'
import PreviewExperience from '../specialist-experience/PreviewExperience'
import ViewExperience from '../specialist-experience/ViewExperience'
import PreviewInnovation from '../specialist-innovation/PreviewInnovation'
import ViewInnovation from '../specialist-innovation/ViewInnovation'
import PreviewAssistance from '../specialist-assistance/PreviewAssistance'
import ViewAssistance from '../specialist-assistance/ViewAssistance'
import PreviewFinancial from '../specialist-financial/PreviewFinancial'
import ViewFinancial from '../specialist-financial/ViewFinancial'
import ViewRegulation from '../specialist-regulation/ViewRegulation'
import ViewVision from '../specialist-vision/ViewVision'

const EndUserSearchTextRoutes = () => {
  return (
    <Routes>
        {/*<Route path="/" element={<PrivateRoute7><DashboardUserScreen /></PrivateRoute7>}></Route>*/}
        <Route path="/" element={<PrivateRoute7><L1SearchScreen /></PrivateRoute7>} />
        <Route path="preview-technology" element={<PrivateRoute7><PreviewTechnology /></PrivateRoute7>} />
        <Route path="/view-technology" element={<PrivateRoute7><ViewTechnology /></PrivateRoute7>} />

        <Route path="preview-alternative" element={<PrivateRoute7><PreviewAlternative /></PrivateRoute7>} />
        <Route path="/view-alternative" element={<PrivateRoute7><ViewAlternative /></PrivateRoute7>} />

        <Route path="preview-experience" element={<PrivateRoute7><PreviewExperience /></PrivateRoute7>} />
        <Route path="/view-experience" element={<PrivateRoute7><ViewExperience /></PrivateRoute7>} />

        <Route path="preview-innovation" element={<PrivateRoute7><PreviewInnovation /></PrivateRoute7>} />
        <Route path="/view-innovation" element={<PrivateRoute7><ViewInnovation /></PrivateRoute7>} />

        <Route path="preview-assistance" element={<PrivateRoute7><PreviewAssistance /></PrivateRoute7>} />
        <Route path="/view-assistance" element={<PrivateRoute7><ViewAssistance /></PrivateRoute7>} />

        <Route path="preview-financial" element={<PrivateRoute7><PreviewFinancial /></PrivateRoute7>} />
        <Route path="/view-financial" element={<PrivateRoute7><ViewFinancial /></PrivateRoute7>} />

        <Route path="/view-regulation" element={<PrivateRoute7><ViewRegulation /></PrivateRoute7>} />

        <Route path="/view-vision" element={<PrivateRoute7><ViewVision /></PrivateRoute7>} />
    </Routes>
  )
}

export default EndUserSearchTextRoutes